import { Environment } from '@util/Environment';
import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';
import { App, Product, WebAssessmentApiClient } from 'hydra-data-types';
import { Firebase } from '../helpers/Firebase';

const USE_LOCAL_FUNCTIONS = process.env.REACT_APP_USE_LOCAL_FUNCTIONS === 'true';

export class ApiClient extends WebAssessmentApiClient<
  firebase.functions.HttpsCallableOptions,
  firebase.functions.HttpsCallableResult
> {
  constructor(overrideApp?: App) {
    super({
      functions: Firebase.functions(),
      baseData: {
        product: (overrideApp ?? Environment.APP) as unknown as Product,
      },
      options: {
        useEmulator: Environment.DEVELOPMENT && USE_LOCAL_FUNCTIONS,
      },
    });
  }
}
